import getEnv from '@/env';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, setCookie } from '../cookieUtils';

export enum SplitFeatureFlag {
  SMB_PHONE_NUMBER_MANDATORY_AB_TEST = 'smb_phone_number_mandatory_ab_test',
  SMB_PHONE_NUMBER_KILL_SWITCH = 'MONARCH-473_smb_phone_number_kill_switch',
  OTTERS_3792_ENABLE_LEASESTARTDATE_FILTER_INPROGRESS = 'otters-3792_enable_leasestartdate_filter_inprogress',
  MONARCH_303_NEW_ENROLLMENT_CONFIRMATION_PAGE_AB_TEST = 'monarch-303-new-enrollment-confirmation-page-ab-test',
  MONARCH_446_SWAP_BUILDINGS_TO_PROPERTY_API = 'MONARCH-446_swap_buildings_to_property_api',
  MONARCH_474_NEW_BROKER_SIGNUP_FORM = 'MONARCH-474_new_broker_signup_form',
  MONARCH_531_TRANSUNION_SMB_PHONE_NUMBER_MANDATORY_AB_TEST = 'MONARCH-531_TRANSUNION_SMB_PHONE_NUMBER_MANDATORY_AB_TEST',
  REN_10732_INFINITE_WATCH_SCRIPT = 'REN-10732_infinite_watch_script', // on since 11/2025
  REN_11352_USE_INVITE_SERVICE_FOR_LL_INVITE = 'REN-11352_USE_INVITE_SERVICE_FOR_LL_INVITE',
  OTTERS_4706_APP_TRACKER_NEW_TABS = 'OTTERS_4706_APP_TRACKER_NEW_TABS',
  OTTERS_4707_APP_TRACKER_NEW_STATUS_PILLS = 'OTTERS_4707_APP_TRACKER_NEW_STATUS_PILLS',
  OTTERS_4671_INVITE_USE_SHARED_LEASE_DETAILS_FORM = 'otters-4671_invite_use_shared_lease_details_form',
}

export const COOKIE_KEY = 'split_anonymous_id';

export const getSplitAnonymousId = (): string => {
  let id = getCookie(COOKIE_KEY);
  if (!id) {
    id = uuidv4();
    setCookie(COOKIE_KEY, id, 365);
  }
  return id;
};

export const splitConfig = {
  core: {
    authorizationKey: getEnv().split_io_api_key || '',
    key: getSplitAnonymousId(),
  },
};
